/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Button , Card, Badge , ProgressBar, Row, Col} from 'react-bootstrap'
import {AccountService, ClassesService} from '../services';
import {ClassesStore} from '../store';
import Constants from '../constants.js';
import Table from '../components/general_table.js';
import Translation from '../store/internationalization-store.js';
import Popup from '../components/popup/comfirmation_popup.js'
import FieldGroup from '../components/FieldGroup.js';
import ProductStore from '../store/product-store.js';
import ProductService from '../services/product-service.js';
import Comfirmation from '../components/popup/comfirmation_popup.js';


export default class ClassManagement extends React.Component {


    constructor(props) {
        super();
        this.state = {
            data:ClassesStore.getList(),
            loading:true
        }
    }

    componentWillMount() {
        ClassesStore.on(Constants.GET_MY_CLASSES , ()=>{
            this.setState({
                data:ClassesStore.getList(),
                loading:false,
            })
        })
        ProductStore.on(Constants.GET_USER_DATA,  ()=>{
            var userData = ProductStore.getUserData();
            if (userData.userType == "admin" || userData.userType == "school") {
                this.setState({type:"admin"});
            } else {
                this.setState({type:"teacher"});
            }
        });
    }

    componentDidMount() {
        ClassesService.getMine()
        ProductService.getUserData();
    }


    goTo(){
      window.location.hash = 'settings/importer_classes';
    }

    deleteObject(){
        ClassesService.delete(this.state.deletedClass).then(function(){
            ClassesService.getMine();
            this.setState({showDelete:false, loading:true});
        }.bind(this))
    }

    closeDeleted(){
        this.setState({showDelete:false});
    }

    render(){

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.className + ": " + Translation.get(12789, "Class Message")} 
        onSave={()=>{
            AccountService.createMessageClass(this.state.messageTitle, this.state.messageMessage, this.state.classUid)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />

        if(this.state.loading) {
            return <ProgressBar animated now={45} />
        }

        const columns = [
            {
                dataField: 'name',
                text: Translation.get(819, 'Class Name'),
                sort:true,
                hidden:true,
                searchable: true
            },
            {
                dataField: 'name',
                text: Translation.get(819, 'Class Name'),
                sort:true,
                searchable: false,
                formatter:(cell , row)=>{

                    return <b onClick={function(__class){ window.location.hash = 'classes/overview/' + __class.uid} .bind(this , row )}className="hyperlink">{cell}</b>
                }
            },
            {
                dataField: 'teacher',
                text: Translation.get(858, 'Teachers'),
                searchable: false,
                formatter:(cell , row)=>{
                    var endData = [];
                    if (cell.length == undefined) {
                        return endData;
                    }
                    for (var i =0; i < cell.length; i++) {
                        endData.push(<Badge style={{marginLeft:'5px'}}variant="primary" >{cell[i].name}</Badge>);
                    }
                    return endData;
                },csvFormatter:(cell , row)=>{
                    var data = "";
                    for (var i = 0; i < cell.length; i++) {
                        data += cell[i].name;
                        data += ", ";
                    }
                    return data;
                }
            },{
                dataField: 'assignments',
                searchable: false,
                text: Translation.get(12052 , 'Assignments'),
                formatter:(cell , row)=>{
                    return parseInt(cell);
                }
            },{
                dataField: 'message',
                text:"",
                csvExport: false,
                formatter: (cell, row)=>{
                    return <div onClick={function() {
                        this.setState({addMessage:true, messageMessage:"", messageTitle:"", classUid:row.uid, className:row.name});
                    }.bind(this)}><i class="fas fa-envelope"></i></div>;
                }
            }

        ];

        if (this.state.type == "admin") {
            columns.push({
                dataField: 'delete',
                text:  '',
                csvExport: false,
                formatter: (cell, row)=>{
                    return <div onClick={function() {
                        this.setState({showDelete:true, deletedClass:row.uid});
                    }.bind(this)}><i class="fas fa-trash-alt"></i></div>;
                }
            })
        }

        let btn = <Button onClick={this.goTo}>{Translation.get( 12776 , 'New Class')}</Button>

        return <div>
            <Comfirmation body={Translation.get(12777 , 'Are you sure you wish to delete this class?')} 
                        onSave={this.deleteObject.bind(this)} show={this.state.showDelete} 
                        onHide={this.closeDeleted.bind(this)}/> 
            {popup}
            <Card body>
                <Table component={btn} columns={columns} data={this.state.data} />
            </Card>
        </div>
    }


}